<template>
  <section ref="section" :class="cursor">
    <template v-for="project in projects">
      <article
        ref="article"
        v-for="file in project.files"
        :key="file.filename"
        :data-file="file.filename"
        :data-title="project.title"
        :data-uid="project.uid"
        :data-info="project.showinfo"
        :data-caption="file.caption"
      >
        <img
          v-if="file.type === 'image'"
          v-lazy="file.thumb"
          :data-srcset="file.srcset"
          :src="file.thumb"
          :alt="project.title"
        />
        <video-view v-else :post="file" />
      </article>
    </template>
  </section>
</template>

<script>
// import debounce from "lodash.debounce";
const VideoView = () =>
  import(/* webpackChunkName: "VideoView" */ "@/components/VideoView.vue");

import { isMobile } from "mobile-device-detect";
// import { set } from "vue/types/umd";
export default {
  props: {
    projects: Array,
    active: Boolean
  },
  components: {
    VideoView
  },
  data() {
    return {
      index: 0,
      cursor: "default"
    };
  },
  mounted() {
    if (!isMobile) {
      this.$refs.section.addEventListener("mousemove", this.move);
      this.$refs.section.addEventListener("click", this.click);
    }
    this.$refs.section.addEventListener("scroll", this.scroll);
    this.$root.$on("goTo", this.goToFile);
  },
  watch: {
    active(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.active) {
          var uid = this.$refs.article[this.index].dataset.uid;
          var showinfo = this.$refs.article[this.index].dataset.info;
          var title = this.$refs.article[this.index].dataset.title;
          var caption = this.$refs.article[this.index].dataset.caption;
          var caps = caption.length > 0 ? ",<br>" + caption : "";
          var phrase = title + caps;
          setTimeout(() => {
            this.changeCaption(phrase, uid, showinfo);
          }, 500);
        }
      }
    },
    index(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.active) {
          var uid = this.$refs.article[this.index].dataset.uid;
          var showinfo = this.$refs.article[this.index].dataset.info;
          var title = this.$refs.article[this.index].dataset.title;
          var caption = this.$refs.article[this.index].dataset.caption;
          var caps = caption.length > 0 ? ",<br>" + caption : "";
          var phrase = title + caps;
            setTimeout(() => {
                this.changeCaption(phrase, uid, showinfo);
            }, 500);
            setTimeout(() => {
                this.slideChanged();
            }, 500);
        }
      }
    }
  },
  methods: {
    goToFile(file) {
      const found = this.$refs.article.find(
        element => element.dataset.file === file
      );
      if (found) {
        let newPos = found.offsetTop;
        this.$refs.section.scroll({
          top: newPos,
          behavior: "auto"
        });
      }
    },
    scroll() {
      var scrollPos = this.$refs.section.scrollTop;
      for (var i = 0; i < this.$refs.article.length; i++) {
        var top = this.$refs.article[i].offsetTop;
        var bottom = top + window.innerHeight;
        if (scrollPos >= top && scrollPos < bottom) {
          this.index = i;
          this.slideChanged();
        }
      }
    },
    changeCaption(phrase, uid, showinfo) {
      this.$root.$emit("changeCaption", phrase, uid, Boolean(showinfo));
    },
    slideChanged() {
      this.$root.$emit("slideChanged");
    },
    move(event) {
      var leftZone = window.innerWidth / 3;
      var rightZone = window.innerWidth - leftZone;
      var topZone = window.innerHeight / 3;
      var bottomZone = window.innerHeight - topZone;
      if (event.clientX > leftZone && event.clientX < rightZone) {
        if (event.clientY > 0 && event.clientY < topZone) {
          this.cursor = "up";
        } else if (
          event.clientY > bottomZone &&
          event.clientY < window.innerHeight
        ) {
          this.cursor = "down";
        } else {
          this.cursor = "hide";
        }
      } else {
        this.cursor = "default";
      }
    },
    click(event) {
      var leftZone = window.innerWidth / 3;
      var rightZone = window.innerWidth - leftZone;
      var topZone = window.innerHeight / 3;
      var bottomZone = window.innerHeight - topZone;
      if (event.clientX > leftZone && event.clientX < rightZone) {
        if (event.clientY > 0 && event.clientY < topZone) {
          if (this.index !== 0) {
            var back = this.$refs.section.scrollTop - window.innerHeight;
            this.$refs.section.scroll({
              top: back,
              behavior: "smooth"
            });
          } else {
            var end = this.$refs.article[this.$refs.article.length - 1];
            this.$refs.section.scroll({
              top: end.offsetTop,
              behavior: "smooth"
            });
          }
          this.$root.$emit("slideChanged");
        } else if (
          event.clientY > bottomZone &&
          event.clientY < window.innerHeight
        ) {
          if (this.index !== this.$refs.article.length - 1) {
            var next = this.$refs.section.scrollTop + window.innerHeight;
            this.$refs.section.scroll({
              top: next,
              behavior: "smooth"
            });
          } else {
            var beginning = this.$refs.article[0];
            this.$refs.section.scroll({
              top: beginning.offsetTop,
              behavior: "smooth"
            });
          }
          this.$root.$emit("slideChanged");
        } else {
          if (event.target.tagName !== "VIDEO") {
            this.$root.$emit("toggleCaption");
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  flex: 0 0 100%;
  height: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  scroll-snap-type: y mandatory;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  article {
    width: 100%;
    height: 100%;
    scroll-snap-align: start;
    scroll-snap-stop: always;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &.hide {
    figure {
      cursor: url("data:image/svg+xml;charset=UTF-8,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='20px' height='25px' viewBox='0 0 81.2 99.8' style='enable-background:new 0 0 81.2 99.8;' xml:space='preserve'%3e%3cdefs%3e%3c/defs%3e%3crect width='30.3' height='99.8'/%3e%3crect x='50.9' width='30.3' height='99.8'/%3e%3c/svg%3e")
          10 12,
        pointer;
      &.pause {
        cursor: url("data:image/svg+xml;charset=UTF-8,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='25px' height='25px' viewBox='0 0 100 99.8' style='enable-background:new 0 0 100 99.8;' xml:space='preserve'%3e%3cdefs%3e%3c/defs%3e%3cg%3e%3cpath d='M0,0l100,49.9L0,99.8V0z'/%3e%3c/g%3e%3c/svg%3e ")
            12 12,
          pointer;
      }
    }
  }
}
</style>
